import dataSubjectInfo from './dataSubjectInfo'
import ticketInfo from './ticketInfo'

const tickets = {
  dataSubjectInfo,
  ticketInfo,
}

export default tickets
